import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { I18nService } from './core/i18n';
import { Brand, BrandService } from './core/brand';
import { CONSTANTS } from './shared/constants/constants';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { MerchantService } from './shared/services/merchant.service';
import { LoadingService } from './shared/services/loading.service';
import { AuthorizationService } from './shared/services/authorization.service';
import { IpDataService } from './shared/services/ip-data.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  public brand: Brand;
  public rid: string;
  public isCombinedApplication: boolean;
  public isLoading$: Observable<boolean> = this.loadingService.isLoading;

  constructor(
    private i18nService: I18nService,
    private brandService: BrandService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private title: Title,
    private merchantService: MerchantService,
    private loadingService: LoadingService,
    private auth: AuthorizationService,
    private ipDataService: IpDataService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  public ngOnInit(): void {
    this.brandService.brand.subscribe((brand) => {
      this.loadBrandData(brand);
    });

    this.i18nService.setLanguage(this.i18nService.getDefaultLanguage());
    this.redirect();
  }

  public loadBrandData(brand: Brand): void {
    if (brand.toLowerCase() === CONSTANTS.PAYSAFECARD.brandName) {
      this.rid = brand;
    }

    this.brand = brand;
    this.isCombinedApplication = CONSTANTS[brand.toUpperCase()].isCombinedApplication;
    this.title.setTitle(CONSTANTS[brand.toUpperCase()].pageTitle);
    this.loadFavicon(brand.toUpperCase());
    this.loadTheme(brand.toUpperCase());
  }

  public loadFavicon(brand: string): void {
    const head = this.document.getElementsByTagName('head')[0];
    const favicon = this.document.getElementById('favicon') as HTMLLinkElement;

    if (favicon) {
      favicon.setAttribute('href', CONSTANTS[brand].pageFavicon);
    } else {
      const newFavicon = this.document.createElement('link');
      newFavicon.id = 'favicon';
      newFavicon.rel = 'icon';
      newFavicon.href = CONSTANTS[brand].pageFavicon;

      head.appendChild(newFavicon);
    }
  }

  // TODO: should be refactored in a theme-component
  public loadTheme(brand: string): void {
    const head = this.document.getElementsByTagName('head')[0];
    const themeSrc = this.document.getElementById('theme') as HTMLLinkElement;

    const themeName = CONSTANTS[brand].brandName;

    if (themeSrc) {
      themeSrc.href = `${themeName}.css`;
    } else {
      const style = this.document.createElement('link');
      style.id = 'theme';
      style.rel = 'stylesheet';
      style.href = `${themeName}.css`;

      head.appendChild(style);
    }
  }

  private redirect(): void {
    this.merchantService.getIpDetails().subscribe((ipDetails) => {
      this.ipDataService.setSharedIpData(ipDetails);

      if (!CONSTANTS.US_TERRITORIES_COUNTRY_IDS.includes(ipDetails.countryId)) {
        return;
      }

      this.router.navigate(['contact'], {
        queryParams: {
          brand: this.brand,
          rid: this.rid
        }
      });
    });
  }
}
